module.exports = __webpack_public_path__ + "static/media/About2.e621d2a2.png";